export interface ProjectMemberCandidateProject {
  creator: string;
  members: Array<{ user_id: string }>;
  member_profiles?: Array<{ username: string; nickname?: string }>;
  team_admin_id?: string;
}

export interface ProjectTeamMemberCandidate {
  username?: string;
  nickname?: string;
}

export interface ProjectMemberCandidateOption {
  label: string;
  value: string;
}

export interface ProjectTaskParticipantOption
  extends ProjectMemberCandidateOption {
  isProjectMember: boolean;
}

function getCandidateName(
  userId: string,
  project: ProjectMemberCandidateProject,
  teamMembers: ProjectTeamMemberCandidate[]
) {
  return (
    project.member_profiles?.find((profile) => profile.username === userId)
      ?.nickname ||
    teamMembers.find((member) => member.username === userId)?.nickname ||
    userId
  );
}

function getTeamCandidateIds(
  project: ProjectMemberCandidateProject,
  teamMembers: ProjectTeamMemberCandidate[]
) {
  return Array.from(
    new Set([
      ...teamMembers.map((member) => member.username || ""),
      project.team_admin_id || "",
    ].filter(Boolean))
  );
}

export function buildProjectMemberAddOptions(
  project: ProjectMemberCandidateProject,
  teamMembers: ProjectTeamMemberCandidate[]
): ProjectMemberCandidateOption[] {
  const currentMemberIds = new Set([
    project.creator,
    ...project.members.map((member) => member.user_id),
  ]);
  return getTeamCandidateIds(project, teamMembers)
    .filter((userId) => !currentMemberIds.has(userId))
    .map((userId) => ({
      label: `${getCandidateName(userId, project, teamMembers)}（${userId}）`,
      value: userId,
    }));
}

export function buildProjectTaskParticipantOptions(
  project: ProjectMemberCandidateProject,
  teamMembers: ProjectTeamMemberCandidate[]
): ProjectTaskParticipantOption[] {
  const projectParticipantIds = new Set([
    project.creator,
    project.team_admin_id || "",
    ...project.members.map((member) => member.user_id),
  ].filter(Boolean));
  const orderedIds = Array.from(
    new Set([
      project.creator,
      ...project.members.map((member) => member.user_id),
      project.team_admin_id || "",
      ...getTeamCandidateIds(project, teamMembers),
    ].filter(Boolean))
  );
  return orderedIds.map((userId) => ({
    label: getCandidateName(userId, project, teamMembers),
    value: userId,
    isProjectMember: projectParticipantIds.has(userId),
  }));
}
